import { IMAGE_DESKTOP, IMAGE_MOBILE } from '../elements/assets'

export const FEATURE_TILES = `
...on featureTiles_Entry {
  id
  typeHandle

  heading: headingAdvanced {
    html
  }

  items: featureTiles {
    id
    heading: headingAdvanced {
      html
    }
    description
    ${ IMAGE_DESKTOP }
    ${ IMAGE_MOBILE }
  }
}
`